module.exports = __webpack_public_path__ + "static/media/3hungertext.672f558d.jpg";